import { render, staticRenderFns } from "./ChatListItem.vue?vue&type=template&id=4f61a164&"
import script from "./ChatListItem.vue?vue&type=script&lang=js&"
export * from "./ChatListItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports